import React from 'react';
import { useSelector } from 'react-redux';
import { Row, Col, Form, Button, Badge } from 'react-bootstrap';
import SimpleMantenedorLayout from '../../components/SimpleMantenedorLayout';
import { useMantenedores } from '../../context/MantenedoresContext';
import DirectorioTable from '../../components/Directorio/DirectorioTable';
import ConductorDetalleModal from '../../components/Directorio/ConductorDetalleModal';
import ValidationModal from '../../components/Directorio/ValidationModal';
import CreateConductorModal from '../../components/Directorio/CreateConductorModal';
import { useDirectorio } from '../../hooks/useDirectorio';
import * as FaIcons from 'react-icons/fa';

const Conductores = () => {
  const user = useSelector(state => state.auth.user);
  const { userPermissions } = useMantenedores();
  const permisos = userPermissions?.modules?.directorio || {};
  
  const {
    conductores,
    total,
    loading,
    pageNumber,
    pageSize,
    searchValue,
    empresaId,
    empresas,
    selectedConductor,
    setSelectedConductor,
    conductorDetalle,
    detalleLoading,
    fetchConductorDetalle,
    handleUpdateConductor,
    handleSearchValue,
    handleEmpresaChange,
    handlePageChange,
    handlePageSizeChange,
    // Creación de conductores
    showCreateModal,
    createLoading,
    handleOpenCreateModal,
    handleCloseCreateModal,
    handleCreateConductor,
    // Validaciones
    validationCount,
    showValidationModal,
    validationData,
    validationTotal,
    validationLoading,
    validationPageNumber,
    validationPageSize,
    validationSearchValue,
    selectedUsuarioSpread,
    showEditModal,
    handleOpenValidationModal,
    handleCloseValidationModal,
    handleValidationSearchValue,
    handleValidationPageChange,
    handleValidationPageSizeChange,
    handleEditUsuarioSpread,
    handleCloseEditModal,
    handleAssignUsuarioMovil,
    handleCreateConductorUsuarioMovil,
    // Datos generales
    tiposFlota,
    centrosDespacho,
    sistemasTMS,
    tiposDocumento,
    generalesLoading
  } = useDirectorio(user, permisos);

  const totalPages = Math.max(1, Math.ceil(total / pageSize));

  return (
    <SimpleMantenedorLayout
      mantenedorId="directorio"
      title="Directorio de Conductores"
      subtitle="Gestión de conductores registrados en el sistema"
      iconColor="#17a2b8"
      showBackButton={false}
      breadcrumbs={[
        {
          label: 'Directorio',
          path: '/mantenedores/directorio'
        },
        {
          label: 'Conductores'
        }
      ]}
    >
      <div className="mb-3 d-flex gap-2 align-items-center justify-content-between">
        <div className="d-flex gap-2">
          <Form.Select 
            style={{ width: 220 }} 
            value={empresaId || ''} 
            onChange={e => handleEmpresaChange(e.target.value || null)}
          >
            <option value="">Todas las empresas</option>
            {empresas.map(emp => (
              <option key={emp.id} value={emp.id}>{emp.sigla}</option>
            ))}
          </Form.Select>

          <Form.Control 
            type="text" 
            placeholder="Buscar conductor (mín. 5 caracteres)" 
            style={{ width: 320 }} 
            value={searchValue} 
            onChange={e => handleSearchValue(e.target.value)} 
          />
        </div>

        <div className="d-flex gap-2">
          {/* Botón Nuevo Conductor */}
          {permisos.canCreate && (
            <Button
              variant="primary"
              onClick={handleOpenCreateModal}
              className="d-flex align-items-center gap-2"
              disabled={createLoading}
            >
              <FaIcons.FaUserPlus />
              Nuevo Conductor
            </Button>
          )}

          {/* Botón de errores */}
          <Button
            variant="outline-danger"
            onClick={handleOpenValidationModal}
            className="d-flex align-items-center gap-2"
            disabled={validationCount === 0}
          >
            <FaIcons.FaExclamationTriangle />
            UsuariosSpread con error
            {validationCount > 0 && (
              <Badge bg="warning" text="dark">
                {validationCount}
              </Badge>
            )}
          </Button>
        </div>
      </div>

      <DirectorioTable
        conductores={conductores}
        onRowClick={(row) => setSelectedConductor(row)}
        pageIndex={pageNumber - 1}
        pageCount={totalPages}
        onPageChange={page => handlePageChange(page + 1)}
        pageSize={pageSize}
        onPageSizeChange={handlePageSizeChange}
        total={total}
        loading={loading}
      />

      <ConductorDetalleModal
        show={!!selectedConductor}
        onHide={() => setSelectedConductor(null)}
        conductorId={selectedConductor?.id}
        permisos={permisos}
        fetchConductor={fetchConductorDetalle}
        conductor={conductorDetalle}
        onUpdate={handleUpdateConductor}
        loading={detalleLoading}
        empresas={empresas}
      />

      <ValidationModal
        show={showValidationModal}
        onHide={handleCloseValidationModal}
        validationData={validationData}
        validationTotal={validationTotal}
        validationLoading={validationLoading}
        validationPageNumber={validationPageNumber}
        validationPageSize={validationPageSize}
        validationSearchValue={validationSearchValue}
        onSearchChange={handleValidationSearchValue}
        onPageChange={handleValidationPageChange}
        onPageSizeChange={handleValidationPageSizeChange}
        showEditModal={showEditModal}
        selectedUsuarioSpread={selectedUsuarioSpread}
        onEditUsuarioSpread={handleEditUsuarioSpread}
        onCloseEditModal={handleCloseEditModal}
        conductores={conductores}
        empresas={empresas}
        tiposFlota={tiposFlota}
        centrosDespacho={centrosDespacho}
        sistemasTMS={sistemasTMS}
        tiposDocumento={tiposDocumento}
        generalesLoading={generalesLoading}
        onAssignUsuarioMovil={handleAssignUsuarioMovil}
        onCreateConductorUsuarioMovil={handleCreateConductorUsuarioMovil}
      />

      <CreateConductorModal
        show={showCreateModal}
        onHide={handleCloseCreateModal}
        onCreateConductor={handleCreateConductor}
        empresas={empresas}
        tiposFlota={tiposFlota}
        centrosDespacho={centrosDespacho}
        sistemasTMS={sistemasTMS}
        tiposDocumento={tiposDocumento}
        loading={createLoading}
      />
    </SimpleMantenedorLayout>
  );
};

export default Conductores;
